<template>
    <div class="footer">
        <section class="gj-footer">
            <div class="page-module">
               <div class="gj-content">
                   <div class="tab-1">
                       <div class="logo">
                            <img class="img-1" src="~common/images/gujing/logo.png" alt="logo">
                            <img class="img-2" src="~common/images/gujing/logo_txt.png" alt="logo">
                       </div>
                       <p>鲸融网</p>
                       <p class="phone zxrx"><img src="~common/images/gujing/phone.png" alt="phone">咨询热线：0755-86393135</p>
                       <p class="phone gwsj"><img src="~common/images/gujing/phone.png" alt="phone">顾问手机：13556826075</p>
                       <div class="beian"> 
                           <span>© 2017-2025 鲸融网 版权所有 <a href="https://beian.miit.gov.cn" target="_blank">{{gICPBNNo}}</a>&nbsp;&nbsp;
                            <a :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${recordcode}`" target="_blank">{{gGNBNNo}}</a></span>
                        </div>
                   </div>
                  
                   <div class="tab-3">
                       <div class="qrcode">
                           <img src="https://img.capwhale.com/gj_dyh.jpg" alt="logo">
                       </div>
                   </div>
               </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'pageFooter',
    data() {
        return {
            friendHref: [
                {name:'股权激励', href: ''},
                {name:'乐晴智库', href: ''},
                {name:'行行查', href: ''},
                {name:'天使投资', href: ''},
                {name:'权查查', href: ''},
                {name:'财经腾飞网', href: ''},
                {name:'杭州律师苏州律师', href: ''},
                {name:'数据分析', href: ''},
                {name:'纳税筹划', href: ''},
                {name:'人力资源管理系统', href: ''},
                {name:'知识产权', href: ''},
                {name:'企业网盘', href: ''},
                {name:'商业计划书', href: ''},
                {name:'企查查', href: ''}
            ],            
            gICPBNNo:"粤ICP备17145857号",//ICP备案号
            gGNBNNo:"粤公网安备44030502003760号",//公安备案号
            recordcode:"44030502003760"
        }
    },
    mounted() {
        let hostname=location.hostname;
        if(hostname.indexOf("zj178.com")>=0){
            this.gICPBNNo="蜀ICP备2020035836号"
            this.gGNBNNo="川公网安备51019002003414号"
            this.recordcode="51019002003414"
        }
    },
    methods: {},
    watch: {},
    filters: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
   .footer {
        .page-module {
            margin: auto;
            padding: 0 10px;
            box-sizing: border-box;
            max-width: 1200px;
            min-width: 1200px;
            overflow: hidden;
        }
        .gj-footer {
            clear: both;
            position: relative;
            z-index: 3;
            margin-top: 40px;
            padding: 35px 0 40px 0;
            min-width: 1200px;
            color: #fff;
            font-size: 14px;
            border-top: none;
            background: #004A99;
        }
        a:hover {
            text-decoration: underline;
        }
        .gj-content {
            overflow: hidden;
        }
        .title {
            padding-bottom: 10px;
            border-bottom: solid 1px #fff;
        }
        .tab-1 {
            float: left;
            .logo {
                margin-bottom: 30px;
                img {
                    display: inline-block;
                }
                .img-1 {
                
                    width: 117px;
                    height: 39px;
                }
                .img-2 {
                    padding: 3px 0;
                    padding-left: 20px;
                    margin-left: 20px;
                    border-left: solid 1px #fff;
                    width: 166px;
                    transform: translateY(-10px);
                    -webkit-transform: translateY(-10px);
                    -ms-transform: translateY(-10px);
                    -moz-transform: translateY(-10px);
                    -o-transform: translateY(-10px);
                }
            }
            p {
                margin-top: 10px;
            }
            .phone {
                margin-top: 13px;
                font-size: 16px;
                img {
                    margin-right: 10px;
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    transform: translateY(2px);
                    -webkit-transform: translateY(2px);
                    -ms-transform: translateY(2px);
                    -moz-transform: translateY(2px);
                    -o-transform: translateY(2px);
                }
            }
            .beian {
                margin-top: 20px;
                span,
                a {
                    color: #fff;
               }
            }
        }
        
        .tab-3 {
            float: right;
            margin-right: 20px;
            .qrcode {
                img {
                    margin-top: 19px;
                    width: 140px;
                    height: 140px;
                }
            }

        }
        .gj-friend {
            clear: both;
            margin-top: 43px;
            a {
                color: #FFFFFF;
                padding-right: 10px;
            }
        }
    }
    

</style>